import React from "react";

import styles from "./SuccessLinked.module.scss";
import Button from "../../UiComponents/Button";

const SuccessLinked = ({ userName, senderOwner }) => {
  return (
    <div className={styles.container}>
      <p>
        Votre compte est bien lié à <span>{senderOwner}.</span>{" "}
      </p>

      <a href="https://dashboard.hearing-space.com">
        <Button
          text={"je me connecte au dashboard d'Hearing Space"}
          styles={"btnPrimary"}
        />
      </a>
    </div>
  );
};

export default SuccessLinked;
